import { AxiosRequestConfig } from "axios";
import ApiConstants from "../constants/ApiConstants";
import http from "../http";
import moment from 'moment'
import { FORMAT } from "../constants/Constant";
export interface MakePaymentType  {
    payrunId: string;
    totalCost: number;
    firstPayDate: string;
    backRout: string;

}

export interface GIROConfig  {
    limit: number,
    currentPage: number,
    from: string,
    to: string
}
const defaultConfig = {
    limit: 20,
    currentPage: 1,
    from: moment().startOf('month').format(FORMAT.MMDDYYYY_2),
    to: moment().endOf('month').format(FORMAT.MMDDYYYY_2)
}
export default class GiroService {
    static defaultMakePaymentValues = {
        payrunId: '',
        totalCost: 0,
        firstPayDate:'',
        backRout: ''
    }
    static GIROConfig:GIROConfig = defaultConfig
    static MakePaymentValues:MakePaymentType = GiroService.defaultMakePaymentValues;
    static getGiroList(param) {
        const url = ApiConstants.URL.GIRO.GIRO_LIST;
        return http.get(url,{params:param});
    }
    static getPaymentDetails(param) {
        const url = ApiConstants.URL.GIRO.PAYMENT_DETAILS;
        return http.get(url,{params:param});
    }
    static generateGIRO(param) {
        const config: AxiosRequestConfig = {
            responseType: "blob"
        }
        const URL = ApiConstants.URL.GIRO.GENERATE_GIRO;
        return http.post(URL,param);
    }

    static generateGIROXLS(param) {
        const config: AxiosRequestConfig = {
            responseType: "blob"
        }
        const URL = ApiConstants.URL.GIRO.GENERATE_GIRO;
        return http.post(URL,param, config);
    }
}